import React from "react";
import { Button, Card, Col, Container, Row } from "react-bootstrap";
import Image from "../assets/Img1.png";
import { CiMail } from "react-icons/ci";
import { NavLink } from "react-router-dom";

const Contact = () => {
  return (
    <div>
      <Container
        fluid
        style={{
          backgroundColor: "white",
        }}
      >
        <Row xs={1} lg={2}>
          <Col>
            <p
              style={{
                fontSize: "50px",
                margin: "60px 0 5px 4px",
              }}
            >
              <b> Contact Us</b>
            </p>
            <Card className="border border-0 mb-5 me-5">
              <Card.Body>
                <div>
                  <div>
                    <p>
                      Whether you have a question, need assistance, or want to explore how our innovative Cybersecurity strategies can empower your Business, We’re here to help — connect with us now!
                    </p>
                  </div>
                  <div className="text-center">
                    <Button
                      className="text-center mt-5"
                      style={{
                        color: "#002D62",
                        border: "none",
                        background: "transparent",
                      }}
                      as={NavLink}
                      to={"/contact"}
                    >
                      <CiMail /> info@idm360analytics.com{" "}
                    </Button>
                  </div>
                </div>
              </Card.Body>
            </Card>
          </Col>
          <Col className="d-none d-lg-flex">
            <img src={Image} alt="Contact Us" className="img-fluid" />
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Contact;
